module.exports = __webpack_public_path__ + "img/container_front_left.77681919.svg";